import { Avatar, Chip, Typography } from "@mui/material";
import CustomImage from "../../components/CustomImage";

export const getColumns = (currentPage: number, rows: number) => [
    {
        header: "S.No.",
        accessor: "_index",
        render: (_row: any, index?: number) => (currentPage - 1) * rows + (index ?? 0) + 1,
    },
    {
        header: "Logo",
        accessor: "logoUrl",
        render: (item: any) => (
            item.logoUrl ? (
                <CustomImage
                    src={item.logoUrl}
                    style={{ width: 40, height: 40, borderRadius: 4, objectFit: 'contain' }}
                />
            ) : (
                <Avatar sx={{ width: 40, height: 40, borderRadius: 1 }} variant="rounded">
                    {item.name?.charAt(0)}
                </Avatar>
            )
        )
    },
    {
        header: "Name",
        accessor: "name",
        render: (item: any) => (
            <Typography variant="body2" sx={{ fontWeight: 600 }}>{item.name}</Typography>
        )
    },
    {
        header: "Corporate Code",
        accessor: "corporateCode",
        render: (item: any) => (
            <Typography variant="body2" sx={{ fontWeight: 600, whiteSpace: 'nowrap' }}>
                {item.corporateCode || '-'}
            </Typography>
        )
    },
    {
        header: "Company",
        accessor: "companyName",
        render: (item: any) => (
            <Typography variant="body2">{item.companyName || '-'}</Typography>
        )
    },
    {
        header: "Industry",
        accessor: "industry",
        render: (item: any) => (
            <Typography variant="body2">{item.industry || '-'}</Typography>
        )
    },
    {
        header: "Location",
        accessor: "city",
        render: (item: any) => (
            <Typography variant="body2">{item.city}{item.state ? `, ${item.state}` : ''}</Typography>
        )
    },
    {
        header: "Employees",
        accessor: "employeeCount",
        render: (item: any) => (
            <Typography variant="body2">{item.employeeCount || '-'}</Typography>
        )
    },
    {
        header: "Status",
        accessor: "isActive",
        render: (item: any) => (
            <Chip
                label={item.isActive ? 'Active' : 'Inactive'}
                color={item.isActive ? 'success' : 'default'}
                size="small"
            />
        )
    },
];

export const INDUSTRIES = [
    "Technology",
    "Healthcare",
    "Finance",
    "Education",
    "Manufacturing",
    "Retail",
    "Transportation",
    "Construction",
    "Hospitality",
    "Other"
];
